export const iconFontAwesomeCodingCodeCompare = (
	<i className="fa-solid fa-code-compare"></i>
);
